module.exports = __webpack_public_path__ + "static/media/logo_unauth.b2dae833.png";